import React from "react";
import { useNavigate } from "react-router-dom";
import "./home.css";

const DEBUG_HOTSPOTS = false;

// Coordinates are in a 1000x1000 “image space”
const hotspots = [
  {
    id: "about",
    to: "/about",
    label: "Go to About",
    shape: "rect",
    x: 340, y: 230, w: 190, h: 240,
    cursor: "cursor-jam",
    cursorUrl: `${process.env.PUBLIC_URL}/icons/jam48.png`,
  },
  {
    id: "watch",
    to: "/watch",
    label: "Go to Watch",
    shape: "rect",
    x: 700, y: 450, w: 270, h: 220,
    cursor: "cursor-cherries",
    cursorUrl: `${process.env.PUBLIC_URL}/icons/cherries48.png`,
  },
  {
    id: "contact",
    to: "/contact",
    label: "Go to Contact",
    shape: "rect",
    x: 320, y: 600, w: 250, h: 260,
    cursor: "cursor-cheese",
    cursorUrl: `${process.env.PUBLIC_URL}/icons/cheese48.png`,
  },
  {
    id: "shows",
    to: "/shows",
    label: "Go to Shows",
    shape: "rect",
    x: 530, y: 340, w: 220, h: 130,
    cursor: "cursor-dragonfruit",
    cursorUrl: `${process.env.PUBLIC_URL}/icons/dragonfruit48.png`,
  },
  {
    id: "listen",
    to: "/listen",
    label: "Go to Listen",
    shape: "rect",
    x: 50, y: 475, w: 450, h: 130,
    cursor: "cursor-strawberry",
    cursorUrl: `${process.env.PUBLIC_URL}/icons/strawberry48.png`,
  },
  {
    id: "play",
    to: "/play",
    label: "Go to Play",
    shape: "rect",
    x: 100, y: 735, w: 150, h: 100,
    cursor: "cursor-dice",
    cursorUrl: `${process.env.PUBLIC_URL}/icons/dice48.png`,
  },
];

export default function Home() {
  const navigate = useNavigate();

  const onKey = (to) => (e) => {
    if (e.key === "Enter" || e.key === " ") navigate(to);
  };

  return (
    <main className="home-page">
      <div className="hero-map">
        <img
          className="hero-image"
          src={process.env.PUBLIC_URL + "/AlbumCover.jpg"}
          alt="A Quiet Boom album cover"
        />

        <svg
          className="hero-overlay"
          viewBox="0 0 1000 1000"
          preserveAspectRatio="xMidYMid meet"
          aria-label="Interactive navigation"
        >
          {hotspots.map((h) => (
            <g
              key={h.id}
              className={`${DEBUG_HOTSPOTS ? "hotspot debug" : "hotspot"} ${h.cursor}`}
              style={{ "--cursor-image": `url("${h.cursorUrl}")` }}
              role="link"
              tabIndex={0}
              aria-label={h.label}
              onClick={() => navigate(h.to)}
              onKeyDown={onKey(h.to)}
            >
              {h.shape === "rect" ? (
                <rect x={h.x} y={h.y} width={h.w} height={h.h} rx="12" ry="12" />
              ) : (
                <ellipse cx={h.cx} cy={h.cy} rx={h.rx} ry={h.ry} />
              )}
            </g>
          ))}
        </svg>
      </div>
    </main>
  );
}